export class Address {
    area: string;
    block: string;
    city: string;
    country: string;
    department: string;
    fullStreet: string;
    homeType: string;
    houseNumber: string;
    houseType: string;
    startingDate: Date;
    state: string;
    street: string;
    street2: string;
    street3: string;
    street4: string;
    street5: string;
    type: string;
    zip: string;
    constructor() {
        this.area = "";
        this.block = "";
        this.city = "";
        this.country = "";
        this.department = "";
        this.fullStreet = "";
        this.homeType = "";
        this.houseNumber = "";
        this.houseType = "";
        this.startingDate = new Date();
        this.state = "";
        this.street = "";
        this.street2 = "";
        this.street3 = "";
        this.street4 = "";
        this.street5 = "";
        this.type = "";
        this.zip = "";
    }
}